import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography
} from '@one-thd/sui-atomic-components';
import {
  extend,
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { ProductDetails } from '@thd-olt-component-react/product-details'
import { transformBrandName } from '../utils';

const ProductQuestionsHeader = ({ itemId }) => {

  const { data: questionsData, loading: questionsLoading, error: questionsError } = useDataModel('questionsAnswers',
    {
      variables: {
        itemId
      }
    }
  );

  const { data: productData, loading: productLoading, error: productError } = useDataModel('product',
    {
      variables: {
        itemId
      }
    }
  );

  if (
    (productLoading && !productData) || productError
    || (questionsLoading && !questionsData) || questionsError
  ) {
    return null;
  }

  const totalResults = questionsData?.questionsAnswers?.TotalResults || 0;
  const { brandName = '', productLabel = '' } = productData?.product?.identifiers || {};

  const transformedBrandName = transformBrandName(brandName);
  const headerBeginningText = totalResults ? 'Questions and Answers' : 'Be the first to ask a question';

  return (
    <Typography component="h1" variant="h2" weight="display">
      {`${headerBeginningText} for ${transformedBrandName ? transformedBrandName + ' ' : ''}${productLabel}`}
    </Typography>
  );
};

ProductQuestionsHeader.dataModel = extend(
  {
    product: params({
      itemId: stringType().isRequired()
    }).shape({
      itemId: stringType(),
      identifiers: shapeType({
        brandName: stringType(),
        productLabel: stringType(),
      }),
    }),
  },
  ProductDetails,
  ProductDetails.Ratings
);

ProductQuestionsHeader.propTypes = {
  itemId: PropTypes.string.isRequired
};

ProductQuestionsHeader.displayName = 'ProductQuestionsHeader';

export default ProductQuestionsHeader;